module.exports = __webpack_public_path__ + "static/img/Dirty-Twinz.8f083d0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/card/Dirty-Twinz.jpg
// module id = f8oP
// module chunks = 1